import { Metadata, PaymentSearchResult } from '@app/_store';

export class SearchPaymentResponse {
  result: PaymentSearchResult[];
}

export class PatchParticipantResponse {
  name: string;
  email: string;
  mobile: string;
  metadata: Metadata[];
}

export enum SendParticipantActivityLinkResponseStatus {
  success = 0,
  failure = 1,
  needToWait = 2,
}

export class SetActivityImageResponse {
  url: string;
  width: number;
  height: number;
}
